import banner2 from "../assets/banner2.jpg";
import UnifiedServicePage from "./UnifiedServicePage";

export default function SolarPowerServicePage() {
  return (
    <UnifiedServicePage
      title="Solar Power Solutions"
      kicker="Clean and Affordable Energy"
      intro="We design, install, and maintain reliable solar power systems for homes, businesses, institutions, and industrial facilities."
      heroImage={banner2}
      overviewTitle="Power That Works for You"
      overviewText="Our solar solutions are engineered for performance, durability, and long-term savings tailored to your energy profile."
      featureTitle="What We Deliver"
      features={[
        {
          title: "Home & Commercial Solar",
          desc: "Scalable solar systems built for daily reliability and reduced operating costs.",
        },
        {
          title: "On-Grid & Off-Grid Systems",
          desc: "Flexible deployment models based on your location, load, and continuity needs.",
        },
        {
          title: "Battery Storage",
          desc: "Energy storage integration for backup power and improved resilience.",
        },
        {
          title: "Monitoring & Maintenance",
          desc: "Performance tracking and preventive maintenance for high system uptime.",
        },
        {
          title: "Professional Commissioning",
          desc: "Safe installation and technical commissioning by experienced engineers.",
        },
        {
          title: "After-Sales Support",
          desc: "Responsive technical support to keep your system operating efficiently.",
        },
      ]}
      focusTitle="Our Delivery Process"
      focusItems={[
        {
          title: "Assessment",
          desc: "Site visit, load analysis, and project feasibility planning.",
        },
        {
          title: "Design",
          desc: "System architecture and component selection matched to your usage.",
        },
        {
          title: "Installation",
          desc: "Professional implementation and full quality verification.",
        },
        {
          title: "Support",
          desc: "Monitoring, service, and optimization throughout system life.",
        },
      ]}
      testimonyQuote="The team delivered a dependable solar solution with strong technical guidance and after-sales support."
      testimonyAuthor="Client Representative"
      ctaTitle="Ready to Go Solar?"
      ctaText="Talk to our team and get a solar solution designed specifically for your project."
      ctaLabel="Request Consultation"
    />
  );
}
